import moment from 'moment-timezone'

/**
 * Formats an occurrence date string according to the given timezone.
 * Behavior mirrors existing inline formatting used in the entry well.
 * - Parses the input as UTC.
 * - If tz !== 'STZ', converts to the provided timezone before formatting.
 * - Uses moment format "LLLL" and appends timezone abbreviation, except when tz === 'STZ',
 *   where it literally prints "STZ".
 */
export function formatOccurrenceDate(dateStr: string, tz: string): string {
    const mm = moment.tz(dateStr, 'UTC')
    if (tz !== 'STZ') {
        mm.tz(tz)
    }
    return mm.format(`LLLL ${tz === 'STZ' ? '[STZ]' : 'z'}`)
}
